<!--
  --
  -- 説明文コンポーネント
  --
  -- TODO: <a>, <code>, <em>, <strong> などのタグに
  -- 共通のスタイルを与える
  --
  -->
<template>
  <div class="c-description">
    <slot/>
  </div>
</template>

<style lang="scss">
.c-description {
  p:last-child {
    margin-bottom: 0;
  }
}
</style>

<script>
export default {
  name: 'CDescription'
}
</script>
